
document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileDrawer = document.querySelector('[data-mobile-drawer]');

if (menuButton && mobileDrawer) {
  menuButton.addEventListener('click', () => {
    const isOpen = mobileDrawer.classList.toggle('open');
    document.body.classList.toggle('menu-open', isOpen);
    menuButton.setAttribute('aria-expanded', String(isOpen));
  });
}

const motionDisabled = document.body.classList.contains('motion-disabled');
const isIOSWebKit =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

if (!motionDisabled && !isIOSWebKit && 'IntersectionObserver' in window) {
  document.documentElement.classList.add('motion-ready');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.reveal').forEach((element) => {
    observer.observe(element);
  });

  window.setTimeout(() => {
    document.querySelectorAll('.reveal').forEach((element) => {
      element.classList.add('visible');
    });
  }, 1200);
} else {
  document.querySelectorAll('.reveal').forEach((element) => {
    element.classList.add('visible');
  });
}

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const option = select.options[select.selectedIndex];
  const wrapper = select.closest('[data-product-summary]');
  const price = wrapper?.querySelector('[data-price]');
  const button = wrapper?.querySelector('[data-add]');

  if (price && option.dataset.price) {
    price.textContent = option.dataset.price;
  }

  if (button) {
    button.disabled = option.disabled;
    button.textContent = option.disabled ? 'Sold out' : 'Add to Your Stack';
  }
});
